import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-brilho',
  templateUrl: './brilho.component.html',
  styleUrls: ['./brilho.component.scss']
})
export class BrilhoComponent {

  constructor() { }

}
